<template>
  <v-layout>
    <KpAppBar
      v-if="!fullscreen"
      v-model="drawer"
    />
    <KpBaseNavigationDrawer
      v-model="drawer"
      v-model:permanent="permanent"
    >
      <KpNavigationDrawerContent />
    </KpBaseNavigationDrawer>
    <v-main
      data-kp-anchor="layout.default.content"
      :class="{ 'default-layout__nav-drawer-inset': isNavDrawerShellMounted }"
    >
      <RouterView :class="`mx-${layoutOutsideSpacing}`" />
    </v-main>
    <NavBotBar />
  </v-layout>
</template>

<script setup>
import {
  ref, provide, watch,
} from 'vue';

import { useDisplay } from 'vuetify';
import useAppLayout from '~/composables/useAppLayout';
import { useIsNavDrawerShellMounted } from '~/composables/navigation-next/navShell';

import KpAppBar from '~/layouts/KpAppBar.vue';
import KpBaseNavigationDrawer from '~/layouts/KpBaseNavigationDrawer.vue';
import KpNavigationDrawerContent from '~/layouts/KpNavigationDrawerContent.vue';
import NavBotBar from '~/layouts/bottom/NavBotBar.vue';

const drawer = ref(false);
const permanent = ref(false);
const showNotificationsDrawer = ref(false);

provide('showNotificationsDrawer', showNotificationsDrawer);

const { fullscreen, layoutOutsideSpacing } = useAppLayout();
const isNavDrawerShellMounted = useIsNavDrawerShellMounted();

// When we leave lgAndUp, we close the drawer and leave the permanent mode to ensure a good sync
const { lgAndUp } = useDisplay();
watch(lgAndUp, () => {
  if (!lgAndUp.value) {
    drawer.value = false;
    permanent.value = false;
  }
});
</script>

<style scoped lang="scss">
@use '~sass' as *;

/* The folded nav-next drawer is FIXED at the bottom of the viewport (`NavBotBar`) and
   takes no room in the layout: while a drawer shell is mounted, the main area reserves
   its height so that no page ends under it. Handle (3rem, `KpBottomDrawer`) + folded
   cell + iOS safe-area (the drawer adds it to its own height), on top of the bottom
   inset Vuetify's layout already computes. */
.default-layout__nav-drawer-inset {
  padding-bottom: calc(
    var(--v-layout-bottom) + 3rem + #{$navigation-machine-item-height}
    + env(safe-area-inset-bottom, 0px)
  );
}
</style>
